import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30cb96b4")

_pushScopeId("data-v-30cb96b4")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Na twee jaar ziekte wordt uw percentage vastgesteld door het UWV ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Na de medische keuring bepaalt het UWV wat uw ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("arbeidsongeschiktheidspercentage")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" is. Op basis van uw ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("arbeidsongeschiktheidspercentage")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" bepaalt het UWV op welke wettelijke uitkering u recht heeft. ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Uw ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("arbeidsongeschiktheidspercentage")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" drukt uw inkomensverlies uit. Bent u tussen de 80% en 100% arbeidsongeschikt? Dan vindt het UWV dat u volledig arbeidsongeschikt bent en niet meer kan werken. Als het UWV denkt dat u nog kunt herstellen, bent u niet-duurzaam, volledig arbeidsongeschikt. ")
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, " Bent u tussen de 35% en 80% arbeidsongeschikt? Dan bent u gedeeltelijk arbeidsongeschikt. Het UWV denkt dat u nog gedeeltelijk kan werken. ", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Bent u minder dan 35% arbeidsongeschikt? Dan kunt u volgens het UWV nog minimaal 65% van uw loon op uw ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("eerste ziektedag")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" verdienen. ")
const _hoisted_16 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("a", {
    href: "https://www.nvschade.nl/werknemer/hoe-zit-het-met-mijn-inkomen/",
    rel: "noopener",
    target: "_blank"
  }, " Kijk voor meer informatie op NV schade ")
], -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("U bent gezond.")
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" U bent korter dan twee jaar ziek of arbeidsongeschikt. ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Voor de voorbeeldberekening hebben wij het ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("arbeids­ongeschiktheids­percentage")
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" standaard voor u op 50% gezet. Uw bruto loon naast uw uitkering (bijverdiensten) zetten wij standaard op € 0. ")
const _hoisted_23 = /*#__PURE__*/_createVNode("p", null, " Weet u de gegevens wel, dan kunt u in het resultaatscherm deze waardes aanpassen. U kunt dan zien wat dit betekent voor uw financiële situatie bij ziekte of arbeidsongeschiktheid. ", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, " U heeft aangegeven meer dan 80% arbeidsongeschikt te zijn. Denkt u in de toekomst te kunnen herstellen zodat u minder dan 80% arbeidsongeschikt bent? ", -1)
const _hoisted_25 = { class: "button-group" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Ja ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Nee ")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_NVAbbr = _resolveComponent("NVAbbr")
  const _component_Explain = _resolveComponent("Explain")
  const _component_Slider = _resolveComponent("Slider")
  const _component_Button = _resolveComponent("Button")
  const _component_Modal = _resolveComponent("Modal")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_Step = _resolveComponent("Step")

  return (_openBlock(), _createBlock(_component_Step, { step: _ctx.step }, {
    header: _withId(() => [
      (_ctx.isLongSick)
        ? (_openBlock(), _createBlock("h2", _hoisted_1, " Wat is uw arbeids­ongeschiktheids­percentage? "))
        : (_openBlock(), _createBlock("h2", _hoisted_2, " Arbeids­ongeschiktheids­percentage en bijverdiensten "))
    ]),
    footer: _withId(() => [
      _createVNode(_component_Navigation, {
        "event-only": "",
        onNext: _ctx.onNextClicked,
        onPrev: _ctx.prevStep
      }, null, 8, ["onNext", "onPrev"])
    ]),
    default: _withId(() => [
      (_ctx.isLongSick)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("div", null, [
              _hoisted_3,
              _createVNode(_component_Explain, { title: "Wat is uw arbeidsongeschiktheidspercentage?" }, {
                default: _withId(() => [
                  _createVNode("p", null, [
                    _hoisted_4,
                    _createVNode(_component_NVAbbr, null, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }),
                    _hoisted_6,
                    _createVNode(_component_NVAbbr, null, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _hoisted_8
                  ]),
                  _createVNode("p", null, [
                    _hoisted_9,
                    _createVNode(_component_NVAbbr, null, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    }),
                    _hoisted_11
                  ]),
                  _hoisted_12,
                  _createVNode("p", null, [
                    _hoisted_13,
                    _createVNode(_component_NVAbbr, null, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _hoisted_15
                  ]),
                  _hoisted_16
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_17, _toDisplayString(_ctx.percent) + "%", 1),
            _createVNode(_component_Slider, {
              modelValue: _ctx.percent,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.percent = $event)),
              max: 100,
              min: 15
            }, null, 8, ["modelValue"])
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("p", null, [
              (_ctx.state.situation === _ctx.HealthState.Healthy)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _hoisted_18
                  ], 64 /* STABLE_FRAGMENT */))
                : (_ctx.state.situation === _ctx.HealthState.ShortSick)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_19
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("", true),
              _hoisted_20,
              _createVNode(_component_NVAbbr, null, {
                default: _withId(() => [
                  _hoisted_21
                ]),
                _: 1
              }),
              _hoisted_22
            ]),
            _hoisted_23
          ], 64 /* STABLE_FRAGMENT */)),
      (_ctx.showRecoveryModal)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 2,
            title: "Denkt u te kunnen herstellen?",
            onClose: _cache[4] || (_cache[4] = $event => (_ctx.showRecoveryModal = false))
          }, {
            default: _withId(() => [
              _hoisted_24,
              _createVNode("div", _hoisted_25, [
                _createVNode(_component_Button, {
                  "icon-right": "chevron-right",
                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.recoveryNext(false)))
                }, {
                  default: _withId(() => [
                    _hoisted_26
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  "icon-right": "chevron-right",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.recoveryNext(true)))
                }, {
                  default: _withId(() => [
                    _hoisted_27
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["step"]))
})